import type { FilterSection } from "@/types/filter";
import defaultBooleanOptions from "@/utils/constants/defaultBooleanOptions";
// import monthsFilterOption from "@/utils/constants/monthsFilterOption";
// import yearsFilterOption from "@/utils/constants/yearsFilterOption";



const FILTER_SECTIONS: FilterSection[] = [
  {
    key: 'isMultimedia',
    label: 'Is Multimedia?',
    type: 'boolean',
    options: defaultBooleanOptions,
  },
  {
    key: 'isKeyHighlight',
    label: 'Is Key Highlight?',
    type: 'boolean',
    options: defaultBooleanOptions,
  }
  // {
  //   key: 'year',
  //   label: 'Year',
  //   type: 'select',
  //   options: yearsFilterOption,
  // },
  // {
  //   key: 'month',
  //   label: 'Month',
  //   type: 'select',
  //   options: monthsFilterOption,
  // },
];

export default FILTER_SECTIONS;